import React from "react"
import tw from "twin.macro"

const BlogYoutubeVideo = ({ content }) => {
  //checkbox1 => fondo negro
  function youtube_parser(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    var match = url.match(regExp)
    return match && match[7].length == 11 ? match[7] : false
  }
  const idYoutube = youtube_parser(content.data.texto_corto1)
  return (
    <div tw="py-4 md:py-6">
      <div
        css={tw`relative w-full h-0 overflow-hidden`}
        style={{ paddingBottom: "56.25%" }}
      >
        <iframe
          css={tw`absolute w-full h-full top-0 left-0`}
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${idYoutube}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  )
}

export default BlogYoutubeVideo
